<template>
    <div class="row" style="padding-left:15px;padding-right:15px;">
        <div class="col-md-12 content-item">
            <div class="col-item-zero flex j-center">
                <span>Төлөв</span>
            </div>
            <div class="col-item-one flex j-center">
                <span>Огноо</span>
            </div>
            <div class="col-item-two flex j-center">
                <span>Салбар</span>
            </div>
            <div class="col-item-three flex j-center" v-if="!memberActivePoint">
                <span>Хуримтлагдсан оноо</span>
            </div>
            <div class="col-item-four flex j-center" v-if="!memberActivePoint">
                <span>Ашигласан оноо</span>
            </div>
            <div class="col-item-five flex j-center" v-if="memberActivePoint">
                <span>Идэвхжсэн оноо</span>
            </div>
            <div class="col-item-six flex j-center">
                <span>Нийт дүн</span>
            </div>
            <div class="col-item-seven flex j-end" style="flex:1;">
                <span>Картын дугаар</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['memberActivePoint']
}
</script>


<style >
@media only screen and (max-width: 767px) {
    .content-item{
        display: none!important;   
    }
}
</style>